if (customElements && !customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.observer = undefined;
    }

    connectedCallback() {
      this.initializeRecommendations(this.dataset.productId);
    }

    initializeRecommendations(productId) {
      if (this.observer) {
        this.observer.unobserve(this);
      }

      this.observer = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) {
            return;
          }

          observer.unobserve(this);
          this.loadRecommendations(productId);
        },
        { rootMargin: '0px 0px 400px 0px' }
      );

      this.observer.observe(this);
    }

    loadRecommendations(productId) {
      fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('.card-wrapper')) {
            this.hideSection();
            return;
          }

          this.initSlider();
        })
        .catch((e) => {
          console.error(e);
        });
    }

    hideSection() {
      const sectionRoot = this.closest('.related-products');

      if (sectionRoot) {
        sectionRoot.style.display = 'none';
      }
    }

    initSlider() {
      const container = this.querySelector('[data-role="slider"]');

      if (!container) {
        return;
      }

      if (typeof Swiper === 'undefined') {
        console.error('ProductRecommendations: Swiper is not loaded');
        return;
      }

      new Swiper(container, {
        slidesPerView: 1.2,
        spaceBetween: 8,
        breakpoints: {
          375: {
            slidesPerView: 2.2,
            spaceBetween: 8
          },
          750: {
            slidesPerView: 3.2,
            spaceBetween: 24
          },
          990: {
            slidesPerView: 4,
            spaceBetween: 24
          }
        }
      });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
